export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  modal: {
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
  },
  messageInputWrapperPrivate: {
    padding: 6,
    marginRight: 7,
    backgroundColor: theme.palette.mode === 'light' ? '#F9F9F9' : '#294056',
    display: 'flex',
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
    borderRadius: 20,
    flex: 1,
    position: 'relative',
  },
  buttonEnable: {
    color: theme.palette.mode === 'light' ? 'grey' : '#eee',
  },
  buttonDisable: {
    color: '#bdbdbd',
  },
});
